export const CONFIG_HEADERS = {
	Accept: "application/json",
	"Access-Control-Allow-Origin": "*",
	"ngrok-skip-browser-warning": "6024",
};
